import { Typography } from '../../../atoms/typography/typography';
import { HTMLAttributes } from 'react';
import { FeaturedIcon } from '../../../ui';
import { mapper } from '@maia/icons';
import { twMerge } from 'tailwind-merge';

type Props = {
  icon: string;
  title: string;
  price: string;
} & Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export function DropdownProduct(props: Props) {
  const { icon, title, price, className, ...rest } = props;

  return (
    <div className={twMerge('flex items-center gap-x-12', className)} {...rest}>
      <div className="flex flex-1 items-center gap-x-12">
        <FeaturedIcon
          size="xs"
          variant="light-square"
          className="text-primaryMain"
          icon={mapper(icon)}
        />
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-grayscale600"
        >
          {title}
        </Typography>
      </div>

      <Typography
        variant="body-xs"
        weight="medium"
        className="text-grayscale300"
      >
        {price}
      </Typography>
    </div>
  );
}
